import React from 'react'
import PropTypes from 'prop-types'
import { RESPONSIVE_BREAKPOINT_PAGES } from 'constants/responsiveBreakpoints'
import {
  RESPONSIVE_BREAKPOINT_VERSIONS,
  ResponsiveBreakpointsProvider,
  useResponsiveBreakpointsVersion
} from 'contexts/ResponsiveBreakpointsContext'
import useResponsiveBreakpointsRollout, {
  RESPONSIVE_BREAKPOINT_ROLLOUT_STATUS
} from 'utils/hooks/useResponsiveBreakpointsRollout'

const DISPLAY_CONTENTS_STYLE = Object.freeze({ display: 'contents' })

const PlaybarVersionMarker = ({ children, isPending }) => {
  const version = useResponsiveBreakpointsVersion()

  return (
    <div
      aria-busy={isPending || undefined}
      data-responsive-breakpoints={version}
      data-responsive-breakpoints-page={RESPONSIVE_BREAKPOINT_PAGES.PLAYBAR}
      data-responsive-breakpoints-status={isPending ? 'pending' : undefined}
      style={DISPLAY_CONTENTS_STYLE}>
      {children}
    </div>
  )
}

PlaybarVersionMarker.propTypes = {
  children: PropTypes.node.isRequired,
  isPending: PropTypes.bool.isRequired
}

const PlaybarWithRollout = ({ children }) => {
  const rolloutStatus = useResponsiveBreakpointsRollout(
    RESPONSIVE_BREAKPOINT_PAGES.PLAYBAR
  )
  const isPending =
    rolloutStatus === RESPONSIVE_BREAKPOINT_ROLLOUT_STATUS.PENDING
  const version = isPending
    ? RESPONSIVE_BREAKPOINT_VERSIONS.LEGACY
    : rolloutStatus

  return (
    <ResponsiveBreakpointsProvider value={version}>
      <PlaybarVersionMarker isPending={isPending}>
        {children}
      </PlaybarVersionMarker>
    </ResponsiveBreakpointsProvider>
  )
}

PlaybarWithRollout.propTypes = {
  children: PropTypes.node.isRequired
}

export default PlaybarWithRollout
